import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FeatureTypography = styled(Typography)(({theme}) => ({
  color: theme.palette.primary.contrastText
}));